module.exports = __webpack_public_path__ + "static/media/wyre.c0b0383c.png";